function parcel(state = {
  parcel: null,
  parcels: null,
  fetching: false,
  fetched: false,
  error: null,
  insured_value_error: false,
  insured_value_update_error: null,
  less_than_zero_error_message: false,
  insured_value_nan_error_message: false,
  display_error_message:false,
  updated_parcel:null,
  parcel_fetching: false,
  getParcel: false,
  prohibited_fetching:false,
  getProhibited:false,
  notification_fetched:false,
  notification:null,
  notification_error:false,
  update_notification:null,
  cart_fetching: false,
  getCartData: false,
  cartData: null,
  parcel_updating: false,
}, action){
  switch (action.type) {
      case 'GET_PARCEL_FETCHING':{
        return{
          ...state,
          parcel_fetching: true,
          getParcel: false,
        }
      }
      case 'GETPARCEL_USER_FULFILLED':{
        return{
          ...state,
          parcel_fetching:false,
          getParcel: true,
          parcels: action.payload,
        }
      }
      case 'GETPARCEL_USER_REJECTED':{
        return{
          ...state,
          getParcel: false,
          error: action.payload,
        }
      }
      case 'GETPROHIBITED_PARCEL_FETCHING':{
        return{
          ...state,
          prohibited_fetching: true,
          getProhibited: false,
        }
      }

       case 'GETPROHIBITED_PARCEL_FULFILLED':{
        return{
          ...state,
          prohibited_fetching:false,
          getProhibited: true,
          prohibited: action.payload,
        }
      }
      case 'UPDATE_INSURED_VALUE_FULFILLED':{
        return{
          ...state,
          fetching:false,
          fetched:true,
          insured_value_update_error:null,
          insured_value_error: false,
          display_error_message:false,
          updated_parcel:action.payload,
        }
      }
      case 'UPDATE_INSURED_VALUE_REJECTED':{
        return{
          ...state,
          fetching:false,
          insured_value_error: true,
          insured_value_update_error:action.payload,
          display_error_message:true,
        }
      }
      case 'RESET_INSURED_VALUE_ERROR':{
        return{
          ...state,
          fetching:false,
          insured_value_error: false,
          insured_value_update_error:[],
          updated_parcel:null
        }
      }
      case 'REMOVE_INSURED_VALUE_ERROR_MESSAGE':{
        return{
          ...state,
          insured_value_error:false,
          display_error_message:false,
          less_than_zero_error_message:false,
          insured_value_nan_error_message:false,
          updated_parcel:null,
        }
      }
      case 'SHOW_INSURED_VALUE_ERROR_MESSAGE':{
        return{
          ...state,
          display_error_message:true,
        }
      }
      case 'SHOW_INSURED_VALUE_LESS_THAN_ZERO_ERROR_MESSAGE':{
        return{
          ...state,
          less_than_zero_error_message:true,
        }
      }
      case 'SHOW_INSURED_VALUE_NAN_ERROR_MESSAGE':{
        return{
          ...state,
          insured_value_nan_error_message:true,
        }
      }
      case 'GET_PARCEL_FULFILLED':{
        return{
          ...state,
          fetching:false,
          fetched:true,
          parcel: action.payload,
        }
      }
      case 'GET_PARCEL_REJECTED':{
        return {
          ...state,
          fetched:false,
          error: action.payload,
        }
      }
      case 'PARCEL_FETCHING':{
        return {
          ...state,
          fetching:true,
          fetched:false,
          error: action.payload,
        }
      }
      case 'GET_NOTIFICATION_FULFILLED':{
        return{
          ...state,
          notification_fetched: true,
          notification: action.payload,
        }
      }
      case 'GET_NOTIFICATION_REJECTED':{
        return {
          ...state,      
          error: action.payload,
          notification_fetched:false,
          notification_error:true,
          notification:null,
        }
      }
      case 'READ_NOTIFICATION_FULFILLED':{
        return{
          ...state,
          update_notification: action.payload,
        }
      }
      case 'READ_NOTIFICATION_REJECTED':{
        return {
          ...state,      
          error: action.payload,
          update_notification:null,
        }
      }
      case 'GET_CART_DATA_FETCHING':{
        return{
          ...state,
          cart_fetching: true,
          getCartData: false,
        }
      }
      case 'GET_CART_DATA_FULFILLED':{
        return{
          ...state,
          cart_fetching:false,
          getCartData: true,
          cartData: action.payload,
        }
      }
      case 'GET_CART_DATA_REJECTED':{
        return{
          ...state,
          getCartData: false,
          error: action.payload,
        }
      }
      case 'PARCEL_UPDATING':{
        return{
          ...state,
          parcel_updating: true,
        }
      }
      case 'PARCEL_UPDATED':{
        return{
          ...state,
          parcel_updating: false,
        }
      }
        default: break
   }
   return state;
}
export default parcel;



/** WEBPACK FOOTER **
 ** ./src/reducers/parcel.js
 **/